import docsCopros from './docsCopros.utils'

const Utils = {
  docsCopros,
}

export default Utils
